import Script from "next/script";
import React from "react";
import { DOM_CAPTURE_QUERY_PARAM } from "@2u-landing-pages/utils/tagular-cookie-domain";

interface OneTrustSnippetProps {
  id?: string;
  src?: string;
}

/**
 * DomCapture=true only.
 * Snapshot C0002 at first OneTrust group report (US opt-out vs non-US opt-in),
 * then sync Cohesion when performance consent is active — no banner maySync gate.
 */
const ONE_TRUST_BANNER_SCRIPT = `
(function () {
  if (new URLSearchParams(location.search).get("${DOM_CAPTURE_QUERY_PARAM}") !== "true") return;

  var c0002AtLoad = null;

  function hasPerformanceConsent() {
    var groups = window.OnetrustActiveGroups || "";
    return groups.indexOf("C0002") !== -1;
  }

  /** First non-empty OnetrustActiveGroups this page view → US if C0002 already on. */
  function captureConsentAtLoad() {
    if (c0002AtLoad !== null) return;
    var groups = window.OnetrustActiveGroups;
    if (groups === undefined || groups === null || groups === "") return;
    c0002AtLoad = groups.indexOf("C0002") !== -1;
    window.__domCaptureConsent = { c0002AtLoad: c0002AtLoad };
  }

  function syncIfAllowed() {
    captureConsentAtLoad();
    // US load or non-US after Accept: C0002 on → sync. Reject drops C0002 (SDK prevWrapper still revokes).
    if (!hasPerformanceConsent()) return;
    if (typeof window.cohesion === "function" && window.cohesion.consent) {
      window.cohesion.consent("syncOneTrust");
    }
  }

  var prevWrapper = typeof window.OptanonWrapper === "function" ? window.OptanonWrapper : function () {};
  window.OptanonWrapper = function () {
    prevWrapper();
    captureConsentAtLoad();
    syncIfAllowed();
  };
})();
`;

export const OneTrustSnippet: React.FC<OneTrustSnippetProps> = ({ id = "", src }) => {
  if (!id) {
    throw new Error(`OneTrustSnippet: Missing oneTrustId`);
  }

  const sdkSrc = src || `https://cdn.cookielaw.org/consent/${id}/otSDKStub.js`;

  // Two tags required: external SDK (src) and inline OptanonWrapper/listeners cannot share one <script>.
  // Inline runs immediately after the SDK tag is declared (PR #604 order).
  return (
    <>
      <Script src={sdkSrc} data-domain-script={id} />
      <Script id="optanon-wrapper">{ONE_TRUST_BANNER_SCRIPT}</Script>
    </>
  );
};
